
import { Component, Vue } from 'vue-property-decorator';
import LegalLayout, { ITocItem } from './components/LegalLayout.vue';

@Component({
  components: {
    LegalLayout,
  },
})
export default class TermsAndConditions extends Vue {
  toc: ITocItem[] = [
    { id: 'introduction', title: 'Introduction' },
    { id: 'cookies', title: 'Cookies' },
    { id: 'license', title: 'License' },
    { id: 'comments', title: 'Comments' },
    { id: 'hyperlinking', title: 'Hyperlinking to our Content' },
    { id: 'iframes', title: 'iFrames' },
    { id: 'content-liability', title: 'Content Liability' },
    { id: 'your-privacy', title: 'Your Privacy' },
    { id: 'reservation-of-rights', title: 'Reservation of Rights' },
    { id: 'removal-of-links', title: 'Removal of links' },
    { id: 'disclaimer', title: 'Disclaimer' },
  ];
}
